import { gql } from "@apollo/client";

import { LANGUAGE_REPRESENTATIVE_DIPLOMA_FIELDS } from "../queries/languageRepresentativeDiplomas";

export const CREATE_LANGUAGE_REPRESENTATIVE_DIPLOMA = gql`
  mutation CreateLanguageRepresentativeDiploma(
    $input: UpdateLanguageRepresentativeDiplomaInput!
  ) {
    createCertLanguageRepresentativeDiploma(input: $input) {
      ...LanguageRepresentativeDiplomaFields
    }
  }
  ${LANGUAGE_REPRESENTATIVE_DIPLOMA_FIELDS}
`;

export const UPDATE_LANGUAGE_REPRESENTATIVE_DIPLOMA = gql`
  mutation UpdateLanguageRepresentativeDiploma(
    $id: ID!
    $input: UpdateLanguageRepresentativeDiplomaInput!
  ) {
    updateCertLanguageRepresentativeDiploma(id: $id, input: $input) {
      ...LanguageRepresentativeDiplomaFields
    }
  }
  ${LANGUAGE_REPRESENTATIVE_DIPLOMA_FIELDS}
`;

export const DELETE_LANGUAGE_REPRESENTATIVE_DIPLOMA = gql`
  mutation DeleteLanguageRepresentativeDiploma($id: ID!) {
    deleteCertLanguageRepresentativeDiploma(id: $id) {
      id
    }
  }
`;
